//region block: pre-declaration
//endregion
function recoverStackTrace(exception, continuation) {
  return exception;
}
function unwrap(exception) {
  return exception;
}
function initCause(_this__u8e3s4, cause) {
}
function recoverStackTrace_0(exception) {
  return exception;
}
//region block: exports
export {
  initCause as initCause1uc19zhi9fkfi,
  recoverStackTrace as recoverStackTrace2i3si2i8nvw1k,
  recoverStackTrace_0 as recoverStackTrace3k4hvtb53ci4z,
  unwrap as unwrap34f7x4f5snsxt,
};
//endregion

//# sourceMappingURL=StackTraceRecovery.mjs.map
